export default "__VITE_ASSET__CdWZQxGT__"